<template lang="html">
  <span>
    <v-stepper-step :complete='complete' :step='step'>
      <v-icon :color='complete ? "primary" : "secondary"'>
        {{ icon }}
      </v-icon>
      <small>{{ title }}</small>
    </v-stepper-step>
    <v-stepper-content :step='step'>
      <slot>
        <p>
          There's Nothing Here
        </p>
      </slot>
    </v-stepper-content>
  </span>
</template>

<script>
export default {
  props: {
    complete: {
      type: Boolean,
      default: false
    },
    step: {
      type: [Number, String],
      default: 1
    },
    icon: {
      type: String,
      default: 'mdi-alert'
    },
    title: {
      type: String,
      default: 'Empty Step'
    }
  },
}
</script>

<style lang="css" scoped>
</style>
